<template>
    <v-data-table
      :headers="headers"
      :items="listado">
      <template
        v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano
          :fecha="item.createdAt">
        </fecha-humano>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
      <v-tooltip
        top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip
        top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Borrar</span>
      </v-tooltip>
    </template>
    </v-data-table>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoListadoInsumos',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  components: {
    FechaHumano,
  },
  data() {
    return {
      headers: [
        {
          text: 'Descripcion',
          align: 'start',
          sortable: false,
          value: 'descripcion',
        },
        { text: 'Orden', align: 'center', value: 'orden' },
        {
          text: '',
          align: 'end',
          width: '150',
          value: 'acciones',
        },
      ],
    };
  },
  methods: {
    editar(frente) {
      eventBus.$emit('editar-frente-contrato', frente);
    },
    borrar(frente) {
      eventBus.$emit('eliminar-frente-contrato', frente);
    },
  },
};
</script>

<style lang="scss">

</style>
